export type Locale = 'ru' | 'en';

/** Нормализует любую BCP-47-строку/`language_code` в поддерживаемую Locale. */
export function resolveLocale(input: string | null | undefined): Locale {
  return typeof input === 'string' && input.toLowerCase().startsWith('en') ? 'en' : 'ru';
}

export function bcp47(locale: Locale): string {
  return locale === 'en' ? 'en-US' : 'ru-RU';
}
